import { useEffect, useMemo } from 'react';

import type { UserCommunication } from '@this+that/models';

import { useGetSnoozedEmails } from '../../services/snoozedEmails.service';
import { useCommunicationIntentsStore } from '../../store';
import { FETCH_POLICY_CACHE_FIRST } from '../../utils/constants';

export const useVisibleUserCommunications = (
  userCommunicationList: UserCommunication[],
): UserCommunication[] => {
  const { snoozedEmails } = useGetSnoozedEmails(FETCH_POLICY_CACHE_FIRST);

  // Subscribed only to trigger a re-render on intent changes; isHiddenByIntent
  // itself reads the current state via getState().
  useCommunicationIntentsStore((state) => state.intents);
  const isHiddenByIntent = useCommunicationIntentsStore(
    (state) => state.isHiddenByIntent,
  );
  const reconcileSnoozedIntents = useCommunicationIntentsStore(
    (state) => state.reconcileSnoozedIntents,
  );

  const snoozedMessageIds = useMemo(
    () => new Set(snoozedEmails.map((snoozedEmail) => snoozedEmail.messageId)),
    [snoozedEmails],
  );

  useEffect(() => {
    reconcileSnoozedIntents(Array.from(snoozedMessageIds));
  }, [snoozedMessageIds, reconcileSnoozedIntents]);

  return (userCommunicationList ?? []).filter(
    (uc) =>
      !isHiddenByIntent(uc.messageId) && !snoozedMessageIds.has(uc.messageId),
  );
};
